<template>
    <div class="card mb-4">
        <div class="card-header bg-primary-light">
            <h1 class="card-title">{{ $t('cars.search.header.panelTitle') }}</h1>
        </div>
        <ul class="list-group list-group-flush">
            <li class="list-group-item" v-html="$t('cars.search.header.pickup', {
                    location: params.pickup_location.name,
                    date: window.moment(params.pickup_date).format($t('format.dateTimeLong')),
                    interpolation: {escape : false}
                })"></li>
            <li class="list-group-item" v-html="$t('cars.search.header.return', {
                    location: params.return_location.name,
                    date: window.moment(params.return_date).format($t('format.dateTimeLong')),
                    interpolation: {escape : false}
                })"></li>
        </ul>
        <table class="table table-bordered table-border-outer-0 mb-0 table-sm text-center">
            <tr class="table-secondary">
                <th class="w-25">{{ $t('cars.search.header.currency') }}</th>
                <th class="w-25">{{ $t('cars.search.header.driverAge') }}</th>
                <th class="w-25">{{ $t('cars.search.header.driverCountry') }}</th>
            </tr>
            <tr>
                <td>
                    <img :src="currencyFlag"
                         :alt="params.currency">
                    <strong>{{ params.currency }}</strong>
                </td>
                <td>{{ params.driver_age }}</td>
                <td>{{ params.driver_country }}</td>
            </tr>
        </table>
        <div class="card-footer text-center">
            <a :href="params.searchFormUrl" class="btn btn-sm btn-secondary">
                <i class="fa fa-fw fa-arrow-left"></i> {{ $t('cars.search.header.refineSearch') }}
            </a>
            <template v-if="isInternal">
                <a :href="params.searchResultUrl + '&new_search=1'" class="btn btn-sm btn-secondary">
                    <i class="fa fa-fw fa-refresh"></i> {{ $t('cars.search.header.redoSearch') }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        computed: {
            currencyFlag() {
                var flags = {
                    USD: 'icon-flag-usa.png',
                    CAD: 'icon-flag-canada.png',
                    EUR: 'icon-flag-euro.png',
                    GBP: 'icon-flag-pound.png'
                };
                return window.env.baseAssetUri + '/images/' + flags[this.params.currency.toUpperCase()];
            }
        }
    };
</script>

<style scoped>

</style>